var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"record-view-container",attrs:{"gutter":20}},_vm._l((_vm.fields),function(field,index){return _c('el-col',{key:index,attrs:{"span":12}},[_c('div',{staticClass:"field-block"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(field.label))]),_c('br'),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.row[field.key]))])])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }